import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SHOPDIGITALMENUPAGE_LEGACY_FIELD_ORDER = [
  { type: 'separator' },
  "meta_description"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  shopDigitalMenuPageDescriptor: _generatedShopDigitalMenuPageDescriptor,
  shopDigitalMenuPageBlocDefinition,
  shopDigitalMenuPageDashboardLayout,
  shopDigitalMenuPageConfig,
  shopDigitalMenuPageResolveConfig,
  shopDigitalMenuPageProperties,
} = doodBlockConfig(
  {
    name: "Shop digital menu page",
    internal_name: "Shop digital menu page",
    defaultParent: [/^Main Layout$/i],
    componentType: 'ShopDigitalMenuPageComponent',
    category: 'page',
    description: "Shop digital menu page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.shop-digital-menu-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    meta_description: propertyValue({
      type: 'textarea',
      value: '',
      options: {
        label: "pages.blocks.shop-digital-menu-page.meta-description.label",
        help: "pages.blocks.shop-digital-menu-page.meta-description.help",
        rows: 3,
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.shop-digital-menu-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.shop-digital-menu-page.fieldset.seo.label",
            fields: ["meta_description"],
          },
          {
            legend: "pages.blocks.shop-digital-menu-page.fieldset.blocks.label",
            fields: ["body"],
          },
        ],
      },
    ],
  })
);

export function shopDigitalMenuPageDescriptor(): IBlockDescriptor;
export function shopDigitalMenuPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function shopDigitalMenuPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedShopDigitalMenuPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedShopDigitalMenuPageDescriptor, shopDigitalMenuPageProperties, fieldOrder);
}

export {
  shopDigitalMenuPageBlocDefinition,
  shopDigitalMenuPageDashboardLayout,
  shopDigitalMenuPageProperties,
  shopDigitalMenuPageConfig,
  shopDigitalMenuPageResolveConfig,
};

export type ShopDigitalMenuPageConfig = typeof shopDigitalMenuPageConfig;
